






import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { AUTH_GET_CLIENT, AUTH_GET_COUNTRY } from '@/store/modules/authentication/types';
import { Client } from '@/store/modules/authentication/interfaces';
import { TupleDictionary } from '@/utils/tupleDictionary';
import { ClientEnum } from '@/enums/client.enum';
import { CountryEnum, CountryType } from '@/enums/country.enum';
import ReportPowerBiContainer from '@/modules/neodash/components/report-powerbi-container/report-powerbi-container.vue';
import { traceLogAccess } from '@/services';
import { ContextEnum } from '@/enums/context.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';

@Component({
  name: 'PbiGroupMapping',
  components: { ReportPowerBiContainer }
})
export default class PbiGroupMappingPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    // BRASIL
    this.dictReports.set([ClientEnum.Honda, CountryEnum.Brasil], { brand: 'Honda', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '14950f67-8ff0-46da-829b-1e2c3afe0c39' });

    this.crrReport = this.dictReports.get([this.client.id, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Mapeamento de Grupos`);
  }
}
